import { render } from "./HomeView.vue?vue&type=template&id=1ae37b4a&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=1ae37b4a&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae37b4a"]])

export default __exports__